// extracted by mini-css-extract-plugin
export var header = "_tq-1";
export var maskBottom = "_tq-6";
export var maskMiddle = "_tq-7";
export var maskTop = "_tq-5";
export var root = "_tq-0";
export var scrollDownButton = "_tq-3";
export var scrollDownButtonHidden = "_tq-4";
export var viewport = "_tq-2";